import React from 'react'

const Index = ({ title }) => {
    return <h2 className="gx-float-left gx-blue-font gx-font-sans-bold gx-mb-0">{title}</h2>
}

export default Index
